export default "__VITE_ASSET__BkOsHYg5__"